import type { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '../../components/interactives/Tooltip'

export function RundownOutputControlButton({
  tooltip,
  icon,
  onClick,
}: {
  tooltip: string
  icon: IconDefinition
  onClick: () => void
}) {
  return (
    <Tooltip>
      <TooltipTrigger>
        <button
          className="w-10 h-10 rounded bg-gray-800/90 hover:bg-gray-800 transition-colors"
          onClick={onClick}
        >
          <FontAwesomeIcon icon={icon} />
        </button>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  )
}
